<script setup lang="ts">
  import type { IMainFooter } from '@/components/main-footer/types'
  const { locale } = useI18n()

  const mainFooter = ref<IMainFooter>({
    logo: null,
    email: null,
    phone: null,
    address: null,
    contactUs: null,
    legalLinks: null,
    awards: null,
    copyright: null,
    paymentLinks: null,
    socials: null,
    googlePrivacyPolicy: '',
    machineTranslationDisclaimer: ''
  })

  const { data, error } = await useFetch<IMainFooter>('/api/storyblok/main-footer', {
    query: { language: locale.value }
  })

  if (!error.value && data.value) {
    mainFooter.value = data.value
  }

  const footerLinks = ref<any | null>(null)

  const { data: footerNavigation, error: footerNavigationError } = await useFetch('/api/storyblok/footer-navigation', {
    query: { language: locale.value }
  })

  if (!footerNavigationError.value && footerNavigation.value) {
    footerLinks.value = footerNavigation.value
  }

  // const jsonLD = computed(() => {
  //   const sameAs = socials.value.map((item) => item.link)

  //   if (!footerSemantics.value) return null

  //   return {
  //     '@context': 'https://schema.org',
  //     '@graph': [
  //       {
  //         '@context': 'https://schema.org',
  //         '@type': 'WebSite',
  //         url: runtimeConfig.public.siteUrl,
  //         potentialAction: {
  //           '@type': 'SearchAction',
  //           target:
  //             runtimeConfig.public.siteUrl.replace(/\/$/, '') +
  //             footerSemantics.value.searchPageUrl +
  //             '?search={search_term_string}',
  //           'query-input': 'required name=search_term_string'
  //         }
  //       },
  //       {
  //         '@context': 'http://schema.org',
  //         '@type': 'Organization',
  //         url: runtimeConfig.public.siteUrl,
  //         logo: footerSemantics.value.logo,
  //         name: 'AirBaltic',
  //         email: footerSemantics.value.email,
  //         address: {
  //           '@type': 'PostalAddress',
  //           streetAddress: footerSemantics.value.address,
  //           addressCountry: 'LV'
  //         },
  //         contactPoint: [
  //           {
  //             '@type': 'ContactPoint',
  //             telephone: footerSemantics.value.phone,
  //             contactType: 'customer service'
  //           }
  //         ],
  //         sameAs
  //       }
  //     ]
  //   }
  // })

  // useHead({
  //   script: [
  //     {
  //       id: 'website-org-json-ld',
  //       type: 'application/ld+json',
  //       innerHTML: JSON.stringify(jsonLD.value)
  //     }
  //   ]
  // })
</script>
<template>
  <footer class="flex flex-col gap-8 bg-grey">
    <div class="container flex flex-col justify-start gap-22 md:flex-row xl:gap-40">
      <MainFooterMenu :footer-links="footerLinks" />
    </div>
    <div class="container flex flex-col gap-8">
      <MainFooterPayments :payment-options="mainFooter.paymentLinks" />
      <MainFooterLegal :legal-links="mainFooter.legalLinks" />
      <MainFooterDisclaimers
        :google-privacy-policy="mainFooter.googlePrivacyPolicy"
        :machine-translation-disclaimer="mainFooter.machineTranslationDisclaimer"
      />
    </div>
    <div class="bg-bt-blue-dark px-4 text-white no-underline">
      <div
        class="container flex flex-col items-start justify-between gap-8 border-b border-white/10 px-10 py-8 sm:flex-row sm:items-center sm:gap-10 sm:px-5 sm:py-10"
      >
        <MainFooterAward
          v-for="award in mainFooter.awards"
          :key="`award-${award._uid}`"
          :award="award"
        />
      </div>

      <div class="container flex flex-col items-center justify-between gap-4 py-8 md:flex-row md:py-7">
        <LazyNuxtLink
          v-if="mainFooter.copyright"
          class="order-2 text-sm/5 text-border no-underline md:order-1"
          :href="mainFooter.copyright.href"
          :target="mainFooter.copyright.target"
          external
        >
          {{ mainFooter.copyright.text }}
        </LazyNuxtLink>
        <div class="order-1 flex flex-col items-center gap-8 md:order-2 md:flex-row">
          <LazyNuxtLink
            v-if="mainFooter.contactUs"
            class="order-2 uppercase md:order-1 md:no-underline"
            :href="mainFooter.contactUs.href"
            :target="mainFooter.contactUs.target"
            external
          >
            {{ mainFooter.contactUs.text }}
          </LazyNuxtLink>
          <MainFooterSocials :social="mainFooter.socials" />
        </div>
      </div>
    </div>
  </footer>
</template>
